<!-- begin::Header -->
@if(chartOptions&&chartOptions?.series){
<div class="card">
  <!-- begin::Body -->
  <div class="card-body">
    <!-- begin::Chart -->
    <div #chartRef [style.height]="'450px'">
      <div>
        <!-- <pre>{{ chartOptions | json }}</pre> -->
      </div>
      <apx-chart
        [series]="chartOptions?.series"
        [chart]="chartOptions?.chart"
        [xaxis]="chartOptions?.xaxis"
        [yaxis]="chartOptions?.yaxis"
        [dataLabels]="chartOptions?.dataLabels"
        [stroke]="chartOptions?.stroke"
        [legend]="chartOptions?.legend"
        [fill]="chartOptions?.fill"
        [states]="chartOptions?.states"
        [tooltip]="chartOptions?.tooltip"
        [colors]="chartOptions?.colors"
        [markers]="chartOptions?.markers"
        [plotOptions]="chartOptions?.plotOptions"
        [labels]="chartOptions?.labels"
        [title]="chartOptions?.title"
        [theme]="chartOptions?.theme"
        [responsive]="chartOptions?.responsive"
      ></apx-chart>
    </div>
    <!-- end::Chart -->
  </div>
  <!-- end::Body -->
</div>
}
